import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {changeUserPassword} from '../../service/authorization';
import {loggedInUserSelector} from '../../store/selectors/auth.selectors';
import {User} from '../../incase-domain/user';
import PasswordInput from './PasswordInput';
import Button from '../../incase-domain/components/button/Button';

function ChangePassword(): JSX.Element {
    const {t} = useTranslation();

    const user = useSelector(loggedInUserSelector);

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [errors, setErrors] = useState<Record<string, string[]>>({});
    const [isLoading, setIsLoading] = useState(false);

    const isDisabled = !password.length || !repeatPassword.length || isLoading;

    function onSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        if (isDisabled) return;

        setIsLoading(true);

        changeUserPassword((user as User)._id, password, repeatPassword)
            .then((res) => {
                if (res.success) {
                    setPassword('');
                    setRepeatPassword('');
                    setErrors({});
                    toast.success(t('toasts.passwordChanged'));
                } else {
                    setErrors(res.errors || {});
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <form className="c-register__form u-flex u-flex-col u-gap-4" onSubmit={onSubmit}>
            <PasswordInput
                onChange={(password) => setPassword(password)}
                value={password}
                placeholder={t('form.passwordPlaceholder')}
                errors={errors}
                name="password"
            />

            <PasswordInput
                onChange={(repeatPassword) => setRepeatPassword(repeatPassword)}
                value={repeatPassword}
                placeholder={t('form.repeatPasswordPlaceholder')}
                errors={errors}
                name="repeatPassword"
            />

            <div className="c-field">
                <Button
                    data-cy="btnChangePassword"
                    color="secondary"
                    size="sm"
                    variant="solid"
                    disabled={isDisabled}
                    className={`c-btn is-secondary u-self-bottom ${isLoading && 'is-loading'}`}
                    type="submit"
                >
                    {t('common.submit')}
                </Button>
            </div>
        </form>
    );
}

export default ChangePassword;
